/** @jsxImportSource jsx-dom */

import { flagHref } from "./shared";

// Design: a 20px ring in the accessible border colour at 80% opacity, with the flag masked to a 17px circle inside it.
// Every sprite flag is 3:2, so it's drawn into a 3x2 viewBox and sliced to fill the circle (as in fragments/flag.htm)
export const RoundFlag = ({ country }: { country: string }) => (
  <span class="tw:inline-flex tw:shrink-0 tw:items-center tw:justify-center tw:size-5 tw:rounded-full tw:bg-fruugo-accessible-border-control/80">
    <span class="tw:block tw:size-[17px] tw:rounded-full tw:overflow-hidden">
      <svg
        class="tw:block tw:w-full tw:h-full"
        viewBox="0 0 3 2"
        preserveAspectRatio="xMidYMid slice"
      >
        <use width="3" height="2" href={flagHref(country)} />
      </svg>
    </span>
  </span>
);

// jsx-dom has no re-render, so swap the flag in place
export function setFlagCountry(flag: Element, country: string) {
  flag.querySelector("use")?.setAttribute("href", flagHref(country));
}
